import { REACT_APP_API_URL } from "../../../../config/config";
import type { RatingCategory } from "../../../../types";
import HtmlDisplay from "../HtmlDisplay";
import RatingPageVpnCard from "./RatingPageVpnCard";

interface RatingPageCategoryCardProps {
  rating: RatingCategory;
  index: number;
}

function RatingPageCategoryCard({
  rating,
  index,
}: RatingPageCategoryCardProps) {
  return (
    <div
      key={index}
      className="container-md mx-auto relative 2xl:px-0 lg:px-4 md:px-4 px-4 pt-3 md:pt-10"
      id={`rating-section-${rating.order}`}
    >
      <section className="max-w-[62.5rem]">
        <div className="flex items-center gap-3 md:gap-4 text-2xl md:text-[2.188rem] font-extrabold tracking-[0.01em] leading-[120%] text-dark mb-4 md:mb-6 text-white">
          {rating.rating_icon ? (
            <img
              src={REACT_APP_API_URL + rating.rating_icon}
              alt=""
              loading="lazy"
              className="w-8 h-8 md:w-11 md:h-11 object-contain flex-shrink-0"
            />
          ) : null}
          {rating.name}
        </div>
        <p className="text-white text-sm font-medium md:text-[1.125rem] leading-[120%] tracking-[0.01em] mb-3 md:mb-12">
          <HtmlDisplay html={rating.description} />
        </p>
      </section>

      {(rating.vpns ?? []).map((vpn, _index) => (
        <RatingPageVpnCard
          key={_index}
          vpn={vpn}
          rating={rating}
          index={_index}
        />
      ))}
    </div>
  );
}

export default RatingPageCategoryCard;
